import { Controller } from '@hotwired/stimulus'
export default class ConfirmModalController extends Controller {
  static targets = ['modal', 'confirmLink', 'content']

  initialize() {
    this.modal = new bootstrap.Modal(this.modalTarget);
  }

  openModal(event) {
    const { confirmHref } = event.currentTarget.dataset;

    this.contentTarget.innerHTML = event.currentTarget.dataset.modalContent;
    this.confirmLinkTarget.href = confirmHref;
    this.confirmLinkTarget.setAttribute('data-method', event.currentTarget.dataset.method || 'post');
    this.modal.show();
  }
}
